var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { grey } from '@mui/material/colors';
import { styled, useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
export const useRoleColor = (role, customRoleColors) => {
    const theme = useTheme();
    const customRoleColor = customRoleColors === null || customRoleColors === void 0 ? void 0 : customRoleColors[role];
    if (customRoleColor) {
        return customRoleColor;
    }
    const colors = {
        student: grey[600],
        instructor: theme.palette.other.brandColor,
        assistant: theme.palette.primary.main,
        presenter: '#C700E6',
        unverified: theme.palette.error.main,
        'class-cam': theme.palette.success.main,
        'sign-language': theme.palette.success.main,
        'instructor-cam': theme.palette.success.main,
        loading: grey[200]
    };
    return colors[role];
};
const StyledTypography = styled(Typography, {
    shouldForwardProp: (prop) => !['roleColor'].includes(prop)
}) `
    background-color: ${({ roleColor }) => roleColor};
    color: ${({ theme, roleColor }) => theme.palette.getContrastText(roleColor)};
    border-radius: 3px;
    padding: 0 5px;
    margin: 0;
    line-height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
`;
export const RoleBadge = forwardRef((props, ref) => {
    const { role, customRoleColors } = props, other = __rest(props, ["role", "customRoleColors"]);
    const roleColor = useRoleColor(role, customRoleColors);
    return _jsx(StyledTypography, Object.assign({ ref: ref, className: 'RoleBadge-root', variant: 'caption', roleColor: roleColor }, other));
});
